module.exports = __webpack_public_path__ + "static/media/Man.0d3dc844.png";